import { api } from '@/lib/axios';

export interface OrderItem {
  id: string;
  productId: string;
  productName: string;
  price: number;
  quantity: number;
  subtotal: number;
  product?: {
    id: string;
    name: string;
    images?: Array<{
      url: string;
      isPrimary: boolean;
    }>;
  };
}

export interface Order {
  id: string;
  orderNumber: string;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  zipCode: string;
  address: string;
  number: string;
  complement?: string;
  neighborhood: string;
  city: string;
  state: string;
  subtotal: number;
  shipping: number;
  total: number;
  status: string;
  paymentMethod?: string;
  paymentStatus: string;
  notes?: string;
  trackingCode?: string;
  carrier?: string;
  shippedAt?: string;
  createdAt: string;
  updatedAt: string;
  items: OrderItem[];
}

export interface OrdersResponse {
  data: Order[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export interface GetAllParams {
  page?: number;
  limit?: number;
  status?: string;
  paymentStatus?: string;
}

export const ordersService = {
  getAll: async (params: GetAllParams = {}): Promise<OrdersResponse> => {
    const { page = 1, limit = 10, status, paymentStatus } = params;
    const queryParams = new URLSearchParams();
    queryParams.append('page', page.toString());
    queryParams.append('limit', limit.toString());
    if (status) queryParams.append('status', status);
    if (paymentStatus) queryParams.append('paymentStatus', paymentStatus);

    const { data } = await api.get(`/orders?${queryParams.toString()}`);
    return data;
  },

  getOne: async (id: string): Promise<Order> => {
    const { data } = await api.get(`/orders/${id}`);
    return data;
  },

  getByOrderNumber: async (orderNumber: string): Promise<Order> => {
    const { data } = await api.get(`/orders/number/${orderNumber}`);
    return data;
  },

  markAsShipped: async (id: string, trackingCode: string, carrier: string): Promise<Order> => {
    const { data } = await api.patch(`/orders/${id}/ship`, { trackingCode, carrier });
    return data;
  },
};
